import styled from "styled-components";
import { List, Popover } from "@material-ui/core";

interface ContainerProps {
  padding?: boolean;
}

export const PopoverStyled = styled(Popover)`
  .MuiPaper-root {
    transform: translate3d(-10px, -30px, 0px) !important;
    box-shadow: none;
    background: transparent;
  }

  .MuiList-root {
    padding: 0;
  }

  .MuiListItem-root {
    padding: 8px 16px;
    cursor: pointer;
    
    &:hover {
      background-color: #f5f5f5;
    }
  }
`;

export const ContainerList = styled.div<ContainerProps>`
  margin: 25px;
  padding: 5px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 8px 20px 0px #00226640;
  .MuiListItem-root {
  padding: ${({ padding }) => padding ? '8px 12px 8px 5px' : '8px 25px 8px 5px'};
  }  
`;

export const ArrowPopover = styled.div`
&::before{
  content: '';
  position: absolute;
  transform: rotate(450deg);
  top: 5px;
  left: 140px;
  border-width: 13px;
  border-style: solid;
  border-color: transparent white transparent transparent;
}
`;

export const Text = styled.span`
  font-family: 'Gotham';
  font-size: 12px;
  font-weight: 500;
  line-height: 13.26px;
  color: #475466;
  white-space: nowrap;
`;

export const Icon = styled.img`
  margin-left: 9px;
  height: 17px;
`;

export const ListStyled = styled(List)`
 li {
  &.MuiListItem-root.Mui-disabled {
    opacity: inherit;
    span {
      opacity: 0.5;
    }
    img {
      opacity: 1 !important;
    }
  }
}
`;